import { useEffect, useMemo, useState } from 'react';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import { useGrupo } from '../../../contexts/produtos/GrupoContext';
import '../produtos/ModalOrdemProduto.css';

const parseOrderNum = (value) => {
    if (value === '' || value === null || value === undefined) {
        return null;
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

const ModalOrdemGrupo = ({
    show,
    onHide,
    grupoSelecionado,
    onGrupoAtualizado,
}) => {
    const { grupos, updateGrupoOrderNum } = useGrupo();
    const [updatingIds, setUpdatingIds] = useState([]);

    useEffect(() => {
        if (!show) {
            setUpdatingIds([]);
        }
    }, [show]);

    const gruposOrdenados = useMemo(() => [...grupos].sort((a, b) => {
        const orderA = parseOrderNum(a.orderNum);
        const orderB = parseOrderNum(b.orderNum);

        if (orderA === null && orderB === null) {
            return a.id - b.id;
        }

        if (orderA === null) {
            return 1;
        }

        if (orderB === null) {
            return -1;
        }

        if (orderA !== orderB) {
            return orderA - orderB;
        }

        return a.id - b.id;
    }), [grupos]);

    const handleChangeOrder = async (grupo, delta) => {
        const currentOrder = parseOrderNum(grupo.orderNum);
        const baseOrder = currentOrder === null ? 0 : currentOrder;
        const nextOrder = baseOrder + delta;

        if (nextOrder < 0 || updatingIds.includes(grupo.id)) {
            return;
        }

        setUpdatingIds((prev) => [...prev, grupo.id]);

        try {
            const grupoAtualizado = await updateGrupoOrderNum(grupo.id, nextOrder);

            if (grupoAtualizado && grupoSelecionado?.id === grupo.id && onGrupoAtualizado) {
                onGrupoAtualizado(grupoAtualizado);
            }
        } finally {
            setUpdatingIds((prev) => prev.filter((id) => id !== grupo.id));
        }
    };

    return (
        <ModalContainer show={show} largura="600px" zIndex={1070}>
            <ModalHeader>
                <h5 className="modal-title">Ordenar Grupos</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
            </ModalHeader>
            <ModalBody>
                <div className="table-responsive">
                    <table className="table table-bordered table-sm align-middle">
                        <thead>
                            <tr>
                                <th style={{ width: '60px', textAlign: 'right' }}>Id</th>
                                <th>Descricao</th>
                                <th style={{ width: '120px' }}>OrdemNum</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gruposOrdenados.length === 0 && (
                                <tr>
                                    <td colSpan="3" className="text-center">
                                        Nenhum grupo encontrado.
                                    </td>
                                </tr>
                            )}

                            {gruposOrdenados.map((grupo) => {
                                const orderNum = parseOrderNum(grupo.orderNum);
                                const isUpdating = updatingIds.includes(grupo.id);
                                const disableUp = isUpdating || orderNum === null || orderNum <= 0;

                                return (
                                    <tr key={grupo.id}>
                                        <td style={{ textAlign: 'right' }}>{grupo.id}</td>
                                        <td>{grupo.descricao}</td>
                                        <td>
                                            <div className="ordem-produto-actions">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() => handleChangeOrder(grupo, -1)}
                                                    disabled={disableUp}
                                                    title="Diminuir ordem"
                                                >
                                                    -
                                                </button>
                                                <span className="ordem-produto-valor">
                                                    {orderNum === null ? '' : orderNum}
                                                </span>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() => handleChangeOrder(grupo, +1)}
                                                    disabled={isUpdating}
                                                    title="Aumentar ordem"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary" onClick={onHide}>
                    Fechar
                </button>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ModalOrdemGrupo;
